import { Card } from "design-system/molecules/Card"
import { cn } from "design-system/utils"
import { ArrowDownToLine, ArrowUpFromLine } from "lucide-react"
import { useTranslation } from "react-i18next"

type Props = {
  value: "Inbound" | "Outbound" | undefined
  onChange: (value: "Inbound" | "Outbound") => void
  disabled?: boolean
}

export function FlowTypeSelector({ value, onChange, disabled }: Props) {
  const { t } = useTranslation()

  const options = [
    {
      value: "Inbound" as const,
      icon: ArrowDownToLine,
      title: t("campaigns.configuration.setup.flow.inbound.title"),
      description: t("campaigns.configuration.setup.flow.inbound.description"),
    },
    {
      value: "Outbound" as const,
      icon: ArrowUpFromLine,
      title: t("campaigns.configuration.setup.flow.outbound.title"),
      description: t("campaigns.configuration.setup.flow.outbound.description"),
    },
  ]

  return (
    <div className="grid grid-cols-2 gap-4">
      {options.map((option) => {
        const isSelected = value === option.value
        return (
          <Card
            key={option.value}
            className={cn(
              "relative cursor-pointer p-4 transition-all",
              isSelected && "border-primary ring-1 ring-primary",
              disabled && "cursor-not-allowed opacity-50",
            )}
            onClick={() => !disabled && onChange(option.value)}
          >
            <div className="flex flex-col gap-1.5">
              <div className="flex flex-row items-center gap-2">
                <option.icon className="size-5" />
                <h3 className="text-base font-semibold">{option.title}</h3>
              </div>
              <div className="flex flex-col gap-1.5">
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {option.description}
                </p>
              </div>
            </div>
          </Card>
        )
      })}
    </div>
  )
}
